import React, { useEffect, useState } from 'react';
import { getStorage, setStorage } from '@utils/localStorage';
import * as Ids from '@utils/ids';
import moment from 'moment';
import Modal from '@roo/roo/Modal';
import { useInterval } from 'react-use';

import * as API from '../../api';
import pageJump from '../../utils/pageJump';

interface LooseObject {
    [key: string]: any;
}

const CACHE_KEY = 'TIMER_INFO_REMIND';
const currentTime = moment().unix();

/**
 * 弹框场景
 * - 周期弹框提醒，每个周期只弹一次
 */
const TimerInfoRemindModal = (params: { token: string }) => {
    const token = params.token;

    const cacheInfoStr = getStorage(CACHE_KEY) || '';

    let cacheInfo: LooseObject = {};
    try {
        cacheInfo = JSON.parse(cacheInfoStr);
    } catch (e) {
        //
    }

    const cache = cacheInfo[token] || {};

    /** 弹框开始时间 */
    const [startTime, setStartTime] = useState<number>(0);
    /** 本地时间 */
    const [localTime, setLocalTime] = useState<number>(currentTime);

    /** 获取弹框展示信息 */
    const getTimerInfo = (time: number) => {
        const startTimeStr = moment.unix(time).format('YYYYMMDD');
        if (startTimeStr === cache) {
            /** 周期内已经展示过 */
            return;
        }
        API.getTimerInfo(token).then(res => {
            const result = res.find(item => {
                return item.bizToken === token;
            });
            if (result && result.isShow) {
                cacheInfo[token] = moment.unix(time).format('YYYYMMDD');
                setStorage(CACHE_KEY, JSON.stringify(cacheInfo));
                Modal.confirm({
                    title: result.title,
                    children: result.content,
                    confirmText: '去操作',
                    onConfirm: () => {
                        pageJump.go('/new_fe/business#/order/preMealReportInfo');
                    },
                });
            }
        });
    };

    /** 获取定时弹窗配置信息 */
    const getTimerConfig = () => {
        API.getTimerConfig(token).then(res => {
            const result = res.find(item => {
                return item.bizToken === token;
            });
            const sTime = result?.period.startTime;
            const eTime = result?.period.endTime;
            if (sTime && eTime) {
                setStartTime(sTime);
                if (sTime && eTime && currentTime > sTime && currentTime < eTime) {
                    /** 在弹框周期内，直接弹框 */
                    getTimerInfo(sTime);
                }
            }
        });
    };

    useEffect(() => {
        if (Ids.getWmPoiId() !== '-1') {
            getTimerConfig();
        }
    }, []);

    useInterval(
        () => {
            setLocalTime(localTime + 1);
            if (startTime && localTime >= startTime) {
                getTimerInfo(startTime);
            }
        },
        startTime && localTime <= startTime && Ids.getWmPoiId() !== '-1' ? 1000 : null,
    );

    if (Ids.getWmPoiId() === '-1') {
        return null;
    }

    return <></>;
};

export default TimerInfoRemindModal;
